/**
 * お問い合わせフォーム
 * - カスタムセレクトボックスの制御
 * - 送信ボタンの制御(個人情報同意チェックボックス)
 */

(function($) {
  'use strict';

  $(function() {
    // ==========================================
    // カスタムセレクトボックスの初期化
    // ==========================================
    
    /**
     * 特定のセレクトボックスを閉じる
     */
    function closeSelect($selectContainer) {
      var $button = $selectContainer.find('.inquiry-select__button');
      var $dropdown = $selectContainer.find('.inquiry-select__dropdown');
      var $select = $selectContainer.find('select');
      
      $button.attr('aria-expanded', 'false');
      $selectContainer.removeClass('is-open');
      if ($dropdown.length > 0) {
        $dropdown.hide();
      }
      
      // バリデーション用にblurイベントを発火
      if ($select.length > 0) {
        $select.trigger('blur');
      }
    }

    /**
     * すべてのセレクトボックスを閉じる
     */
    function closeAllSelects() {
      $('[data-select]').each(function() {
        closeSelect($(this));
      });
    }

    // デバイス判定: タッチデバイスかどうか
    var isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    
    // カスタムセレクトボックスの初期化
    $('[data-select]').each(function() {
      var $container = $(this);
      var $button = $container.find('.inquiry-select__button');
      var $select = $container.find('select');
      var $textElement = $container.find('.inquiry-select__text');

      if ($button.length === 0 || $select.length === 0 || $textElement.length === 0) {
        return;
      }

      // スマートフォン・タブレットの場合はネイティブselectを使用
      if (isTouchDevice) {
        // カスタムUIを非表示にしてネイティブselectを表示
        $container.addClass('inquiry-select--native');
        $button.hide();
        $select.show().css({
          'position': 'relative',
          'opacity': '1',
          'pointer-events': 'auto',
          'width': '100%',
          'height': 'auto',
          'left': '0',
          'top': '0',
          'z-index': '1'
        });
        
        // ネイティブselectの変更を監視
        $select.on('change', function() {
          // バリデーションを再実行
          if (typeof $select.validationEngine === 'function') {
            $select.validationEngine('validate');
          }
        });
        
        return; // この要素の処理を終了
      }

      // 既存のドロップダウンを削除(重複防止)
      $container.find('.inquiry-select__dropdown').remove();

      // ドロップダウンリストを動的に生成
      var $dropdown = $('<div class="inquiry-select__dropdown"></div>');
      var $optionList = $('<ul class="inquiry-select__list" role="listbox"></ul>');

      // select要素の各optionからリストアイテムを生成
      $select.find('option').each(function(index) {
        var $option = $(this);
        var value = $option.val();
        var text = $option.text();
        var isSelected = $option.is(':selected');

        // 空のvalue(デフォルトの「選択ください」など)はドロップダウンリストに追加しない
        if (value === '') {
          return; // continueの代わり
        }

        var $listItem = $('<li class="inquiry-select__option" role="option" data-value="' + value + '">' + text + '</li>');
        
        if (isSelected && value !== '') {
          $listItem.addClass('is-selected');
        }

        // オプションクリック時の処理
        $listItem.on('click', function(e) {
          e.stopPropagation();
          var selectedValue = $(this).data('value');
          var selectedText = $(this).text();

          // select要素の値を更新
          $select.val(selectedValue).trigger('change');

          // 表示テキストを更新
          $textElement.text(selectedText);

          // 選択状態のクラスを更新
          $optionList.find('.inquiry-select__option').removeClass('is-selected');
          $(this).addClass('is-selected');

          // ボタンに選択済みクラスを追加
          if (selectedValue !== '') {
            $button.addClass('is-selected');
          } else {
            $button.removeClass('is-selected');
          }

          // ドロップダウンを閉じる(blur発火も含む)
          closeSelect($container);
          
          // バリデーションを再実行
          if (typeof $select.validationEngine === 'function') {
            $select.validationEngine('validate');
          }
        });

        $optionList.append($listItem);
      });

      $dropdown.append($optionList);
      $container.append($dropdown);

      // 初期状態では非表示
      $dropdown.hide();

      // ボタンクリックでドロップダウンを開閉
      $button.on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var isExpanded = $button.attr('aria-expanded') === 'true';

        // 他のセレクトボックスを閉じる
        closeAllSelects();

        if (!isExpanded) {
          // ドロップダウンを開く
          $button.attr('aria-expanded', 'true');
          $container.addClass('is-open');
          $dropdown.show();

          // ドロップダウンの位置をボタンの直下に調整
          var buttonHeight = $button.outerHeight();
          $dropdown.css({
            'top': buttonHeight + 'px',
            'margin-top': '-1px'
          });

          // バリデーション用にfocusイベントを発火
          $select.trigger('focus');
        }
      });

      // セレクトボックスの変更を監視(直接変更された場合の対応)
      $select.on('change', function() {
        var selectedText = $select.find('option:selected').text();
        $textElement.text(selectedText);

        // 選択済みクラスを追加
        if ($select.val() !== '') {
          $button.addClass('is-selected');
        } else {
          $button.removeClass('is-selected');
        }
      });
    });

    // 外部クリックでドロップダウンを閉じる
    $(document).on('click', function(e) {
      if ($(e.target).closest('[data-select]').length === 0) {
        // 開いているセレクトボックスがあればblurを発火
        $('[data-select].is-open').each(function() {
          var $select = $(this).find('select');
          if ($select.length > 0) {
            $select.trigger('blur');
          }
        });
        closeAllSelects();
      }
    });

    // Escapeキーでドロップダウンを閉じる
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
        // 開いているセレクトボックスがあればblurを発火
        $('[data-select].is-open').each(function() {
          var $select = $(this).find('select');
          if ($select.length > 0) {
            $select.trigger('blur');
          }
        });
        closeAllSelects();
      }
    });

    // ==========================================
    // YubinBango(郵便番号自動入力)との連携
    // ==========================================
    
    /**
     * カスタムセレクトボックスの表示を更新する関数
     */
    function updateCustomSelectDisplay($selectElement) {
      var $container = $selectElement.closest('[data-select]');
      if ($container.length === 0) return;
      
      var $textElement = $container.find('.inquiry-select__text');
      var selectedText = $selectElement.find('option:selected').text();
      
      if ($textElement.length > 0 && selectedText) {
        $textElement.text(selectedText);
      }
    }
    
    // 都道府県セレクトボックスと郵便番号入力フィールド
    var $prefSelect = $('#addr_region');
    var $postalCodeInput = $('#zip');
    var $addressInput = $('#addr');
    
    if ($prefSelect.length > 0 && $postalCodeInput.length > 0) {
      var addressCheckTimer;
      var lastPostalCode = '';
      
      // YubinBangoのchangeイベントを監視
      // YubinBangoはselect要素の値を変更した後、changeイベントを発火します
      $prefSelect.on('change', function() {
        updateCustomSelectDisplay($prefSelect);
      });
      
      // 郵便番号入力フィールドの監視
      // inputイベント: キー入力、ペースト、削除などすべての入力操作で発火
      $postalCodeInput.on('input', function() {
        clearTimeout(addressCheckTimer);
        var currentValue = $(this).val();
        var digitsOnly = currentValue.replace(/[^0-9]/g, '');
        
        // 郵便番号が変更された場合のみ処理
        if (digitsOnly !== lastPostalCode) {
          lastPostalCode = digitsOnly;
          
          // 7桁の郵便番号が入力された場合
          if (digitsOnly.length === 7) {
            // YubinBangoの処理完了を待つ
            addressCheckTimer = setTimeout(function() {
              updateCustomSelectDisplay($prefSelect);
            }, 300);
          } else if (digitsOnly.length < 7) {
            // 7桁未満の場合は都道府県をクリア(編集中)
            // ただし、ユーザーが手動で選択した値は保持したい場合は
            // この処理をコメントアウトしてください
            // $prefSelect.val('');
            // updateCustomSelectDisplay($prefSelect);
          }
        }
      });
      
      // blurイベント: フィールドからフォーカスが外れた時
      $postalCodeInput.on('blur', function() {
        clearTimeout(addressCheckTimer);
        var digitsOnly = $(this).val().replace(/[^0-9]/g, '');
        
        // 7桁の郵便番号がある場合、最終確認
        if (digitsOnly.length === 7) {
          addressCheckTimer = setTimeout(function() {
            updateCustomSelectDisplay($prefSelect);
          }, 300);
        }
      });
      
      // ページ読み込み時に既に値が設定されている場合(バリデーションエラー時など)
      setTimeout(function() {
        if ($prefSelect.val() && $prefSelect.val() !== '') {
          updateCustomSelectDisplay($prefSelect);
        }
        // 初期値を記録
        lastPostalCode = $postalCodeInput.val().replace(/[^0-9]/g, '');
      }, 100);
    }

    // ==========================================
    // 送信ボタンの制御
    // ==========================================
    var $agreeCheckbox = $('#privacy_1');
    var $submitButton = $('#submitButton');

    if ($agreeCheckbox.length > 0 && $submitButton.length > 0) {
      /**
       * 送信ボタンの状態を更新
       */
      function updateSubmitButton() {
        if ($agreeCheckbox.is(':checked')) {
          // チェックされている場合: disabled属性を削除
          $submitButton.prop('disabled', false);
          $submitButton.addClass('is-enabled');
        } else {
          // チェックされていない場合: disabled属性を追加
          $submitButton.prop('disabled', true);
          $submitButton.removeClass('is-enabled');
        }
      }

      // チェックボックスの変更イベントをリスン
      $agreeCheckbox.on('change', updateSubmitButton);

      // 初期状態を設定(ページ読み込み時)
      updateSubmitButton();
    }
  });

})(jQuery);
